export interface WkErrorMessage {
  message: string;
  messageKey: string;
}

export interface WkErrorResponse {
  error: {
    statusCode: number;
    briefSummary: string;
    descriptionURL: string;
    errorKey: string;
    stackTrace: string;
  };
}
